import ProfilePicWithDetails from 'Components/Client/Cases/CaseDetails/ProfilePicWithDetails';
import InfoIcon from 'Components/Icons/InfoIcon';
import { approveToViewApi, casesStatusUpdateApi, closeCaseApi, denyToCloseApi, denyToViewApi, raiseNotificationApi } from 'Constants';
import { Context } from 'Context/Context';
import { getCaseType, getNoOfTimesRequested} from 'Utils';
import React, { useContext, useEffect } from 'react'
import { useState } from 'react'
import { toast } from 'react-toastify';
import { Check } from 'lucide-react';
import AreYouSureModal from './AreYouSureModal';
import useIsMobile from 'Hooks/useIsMobile';

// Cosmetic label rename for display only - kept in sync with the same
// rename in Modals/ProfesssionalDetailsPopUp.jsx so every "profile card"
// in the app reads identically.
const LABEL_DISPLAY = {
    "Law Firm URL": "Firm website",
    "URL": "Firm website",
};
// These are already shown by ProfilePicWithDetails' own header (name +
// legalType/company subtitle), so they're left out of the row list below.
const HEADER_LABELS = ["First name", "Last name", "Designation", "Firm Name"];

function DetailRows({ profData, source }) {
    return (
        <div className='w-full flex flex-col gap-2.5'>
            {Object.entries(profData)
              .filter(([label]) => !HEADER_LABELS.includes(label))
              .map(([label, value], index) => {
                const isLink = label.toLowerCase().includes("link") || label.toLowerCase().includes("url");
                const isExperience = label === "Experience";
                const raw = source?.[value];
                const isList = Array.isArray(raw);
                return (
                    <div className='flex items-start justify-between gap-4 text-[13px]' key={index}>
                        <span className='text-[rgba(20,33,61,.55)] flex-none'>
                            {LABEL_DISPLAY[label] || label}
                        </span>
                        <span className='text-navy font-medium text-right min-w-0 break-words [overflow-wrap:anywhere]'>
                        {isList ?
                          (raw.length === 0 ?
                            <span className='italic'>--All {label?.split(" ")[0]}s--</span> :
                            raw.map((val, i) => (
                              <span key={i}>
                                {value === "casePref" ? getCaseType(val) : val}
                                {i !== raw.length - 1 ? <span>,&nbsp;</span> : ""}
                              </span>
                            ))
                          ) :
                          (raw ?
                            (isLink ?
                            <a target="_blank" rel="noopener noreferrer" className="text-tan underline" href={"https://"+raw}>{raw}</a> :
                            (isExperience ? `${raw} years` : raw))
                            : '--')}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}

function DetailCard({ person, profData }) {
    const isMobile = useIsMobile();
    return (
        // on phones the sheet itself is the card - no second border inside it
        <div className={'w-full flex flex-col items-center font-plexsans ' + (isMobile ? '' : 'rounded-[14px] border border-[rgba(20,33,61,.12)] bg-ivory p-5')}>
            <ProfilePicWithDetails currentProf={person} picSize='l'/>
            <div className='w-full border-t border-[rgba(20,33,61,.1)] my-4'></div>
            <DetailRows profData={profData} source={person}/>
        </div>
    );
}

function ProfessionalDetailsSubModal({inSheet = false, professionalDetails, showTeamupDetails = false, setShowModalProf, setUpdateComp, contentStep, caseDetails}) {

    const [currentProf, setCurrentProf] = useState();
    const [teamupFunderDetails, setTeamupFunderDetails] = useState();
    const [showModal, setShowModal] = useState(false);
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [approveDetail, setApproveDetail] = useState(null);
    const [noOfTimesReq, setNoOfTimesReq] = useState();
    const [currentTab, setCurrentTab] = useState(0);

    const {makeApiCallFunc, userDetails} = useContext(Context);
    let profData = {
        "First name" : "firstName",
        "Last name" : "lastName",
        "Email" : "email",
        "Designation" : "legalType",
        "Firm Name" : "company",
        "Phone number" : "phoneNumber",
        "Experience" : "experience",
        "Law Firm URL" : "lawFirmLink",
        "LinkedIn" : "linkedin"  ,
        "Case Preference": "casePref",
        "State Preference" : "statePref",
    }
    if(currentProf?.userId.isUserFunder)
    {
        profData = {
            "First name" : "firstName",
        "Last name" : "lastName",
        "Email" : "email",
        "Designation" : "legalType",
        "Firm Name" : "company",
        "Phone number" : "phoneNumber",
        "Experience" : "experience",
        "URL" : "lawFirmLink",
        "LinkedIn" : "linkedin"  ,
        "Case Preference": "casePref",
        "State Preference" : "statePref",
        }
    }
    const attorneyProfData = {
        "First name" : "firstName",
        "Last name" : "lastName",
        "Email" : "email",
        "Law Firm URL" : "lawFirmLink",
        "LinkedIn" : "linkedin"
    }
    const caseId = caseDetails?._id;
    const onApprove = (currentDetail) => {
        const detail = currentDetail ? currentDetail : approveDetail;
    setShowModalProf(false);
    console.log("Approve detail", detail);
    if(detail)
    {
    const postData = {
        caseId: caseDetails?._id,
        "userId" : detail?.userId?._id,
        "assistantId" : detail?.assistantId?._id,
        caseStatus: "approved",
    }
    makeApiCallFunc(
        casesStatusUpdateApi,
        postData,
        (data) => {

            const notificationObj = {
                title : "Approved Request - " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber,
                is_read : false,
                sender: "client",
                notificationCategory: 1,
                caseNumber: caseDetails?.caseNumber,
                type: "3",
                receiver:  detail?.userId?._id,
                additionalInfo: {
                    caseId: caseDetails?._id
                },
                content: "Your request to view the case " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber + " has been approved by the potential client. Find this case in your approved cases list. You may now proceed to check for conflicts."
            }
            toast.success("Approved to view");
            setUpdateComp(prev => !prev);
            makeApiCallFunc(raiseNotificationApi,
                notificationObj,
                (data) => console.log(data),
                (error) => console.log(error)
                )
        },
        (data) => {


            console.log(data)
        }
    )
    }
    }
    const onDeny = (attorney) => {
    setShowModalProf(false);


    const postData = {
        caseId: caseDetails?._id,
        "userId" : attorney?.userId?._id,
        "assistantId" : attorney?.assistantId?._id,
        caseStatus: "denied"
    }
    makeApiCallFunc(
        denyToViewApi,
        postData,
        (data) => {
            setUpdateComp(prev => !prev);
            const notificationObj = {
                title : "Denied Request - " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber,
                notificationCategory: 1,
                is_read : false,
                sender: "client",
                caseNumber: caseDetails?.caseNumber,
                type: "4",
                additionalInfo: {
                    caseId: caseDetails?._id
                },
                receiver:  attorney?.userId?._id,
                content: "Your request to view the case "+ getCaseType(caseDetails?.caseType) +" - " + caseDetails?.caseNumber + " has been denied by the client. However you can send request again from the list of all cases."
            }
            toast.success("Denied the professional from viewing the case");
            makeApiCallFunc(raiseNotificationApi,
                notificationObj,
                (data) => console.log(data),
                (error) => console.log(error)
                );
        },
        (data) => {


            console.log(data)
        }
    )
    }

  const onCloseCase = (attorney) => {

    const postData = {
        caseId,
    "userId" : attorney?.userId?._id,
    "assistantId" : attorney?.assistantId?._id,
    }
    makeApiCallFunc(
        closeCaseApi,
        postData,
        (data) => {
            toast.success("Case closed ");
            setUpdateComp(prev => !prev);
            const notificationObj = {
                title : "You have successfully closed " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber ,
                is_read : false,
                sender: "client",
                notificationCategory: 1,
                caseNumber: caseDetails?.caseNumber,
                type: "3",
                receiver:  attorney.userId._id,
                additionalInfo : {
                    "caseId": caseId,
                    "userId": attorney.userId._id
                },
                content: "The case is closed and will be deleted from system in 7 days.",
            }
            notifyAllProf(true, attorney.userId._id, attorney?.teamup);
           return makeApiCallFunc(raiseNotificationApi,
            notificationObj,
             (data) => console.log(data),
             (error) => console.log(error)
            );
        },
        (data) => {
            console.log(data)


        }
    )

}
const onKeepCaseOpen = (attorney) => {

    const postData = {
        caseId,
    "userId" : attorney?.userId?._id,
    "assistantId" : attorney?.assistantId?._id,
        caseStatus: "noConflict"
    }
    makeApiCallFunc(
        casesStatusUpdateApi,
        postData,
        (data) => {
            toast.success("Denied to close");
            //notifyAllProf(false, id);
            setUpdateComp(prev => !prev);

            const notificationObj = {
                title : "The client has denied closing of " + getCaseType(caseDetails?.caseType) + "-"+caseDetails?.caseNumber+".",
                notificationCategory: 1,
                is_read : false,
                sender: "client",
                type: "4",
                receiver:  attorney.userId._id,
                caseNumber: caseDetails?.caseNumber,
                additionalInfo : {
                    "caseId": caseId,
                    "userId": attorney.userId._id
                },
                content: "" + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber + " is open again because the potential client denied that you signed a contract with him/her. Accordingly,this case is open for other attorneys again.",
            }
           return makeApiCallFunc(raiseNotificationApi,
            notificationObj,
             (data) => console.log(data),
             (error) => console.log(error)
            );

        },
        (data) => {


            console.log(data)
        }
    )

}
const notifyAllProf = (isClosed, id, teamup) =>
{
    const notificationObj = {
        title : (isClosed ? getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber + " case is closed by a different attorney" : "The case is open again"),
        is_read : false,
        sender: "professional",
        caseNumber: caseDetails?.caseNumber,
        notificationCategory: 1,
        type: "4",
        sendToAll: {
            role: "attorney",
            sendToAll: true,
            ignoreUserId: teamup ? [teamup?.fromUser?._id, teamup?.toUser?._id] : [id],
        },
        additionalInfo : {
            "caseId": caseId,
            "userId": id
        },
        content: "This is to inform you that this case is"+(isClosed ? " closed" : " open again") + ". You are notified because you showed interest in this case",
    }
    return makeApiCallFunc(raiseNotificationApi,
    notificationObj,
        (data) => console.log(data),
        (error) => console.log(error)
    );
}
    useEffect(() => {

      setCurrentProf(professionalDetails);
        if(professionalDetails?.teamup?.fromUser?._id && showTeamupDetails)
        {
            if(professionalDetails?.teamup?.toUser?._id === professionalDetails?.userId?._id)
            {
                setTeamupFunderDetails({userId : professionalDetails?.teamup?.fromUser});
            }
            else
            {
                setTeamupFunderDetails({userId : professionalDetails?.teamup?.toUser});
            }
        }

      setCurrentTab(professionalDetails?.assistantId ? 1 : 0)
      setNoOfTimesReq(caseDetails?.denied?.length ? getNoOfTimesRequested(caseDetails?.denied, professionalDetails?._id) : 0)
    },[professionalDetails])
  return (

   <div className='w-full h-full flex justify-center items-center'>

    {
        showConfirmPopup &&
        <AreYouSureModal
            onClose={() => setShowConfirmPopup(false)}
            uploadNew={showConfirmPopup}
            text="Please note that this request was submitted by a litigation funder and not an Attorney."
            onSubmit={() => {
                setShowConfirmPopup(false);
                onApprove();
            }}
            buttonName='Approve Request'
            onCancel={() => setShowConfirmPopup(false)}
        />

    }
    {
        showModal &&
        <AreYouSureModal
        uploadNew= {showModal}
        onClose={()=> setShowModal(false)}
        onSubmit = {() => onCloseCase(currentProf)}
        text= "Are you sure you want to close this case ? This action is not reversible."
        />
    }
    <div className='w-full h-full font-plexsans'>

        {
                    professionalDetails?.deniedCount !== 0 && contentStep === 2 &&
                    <div className='flex items-start gap-2 text-[12.5px] text-navy rounded-lg border border-[rgba(230,168,41,.35)] bg-[rgba(230,168,41,.08)] px-3.5 py-2.5 w-full mb-3.5'>
                        <InfoIcon/>
                        <span>This professional has shown interest for this case {professionalDetails?.deniedCount} {professionalDetails?.deniedCount === 1 ? "time" : "times"} before</span>
                    </div>
        }

        {
            currentProf?.assistantId &&
            <div className='flex w-full rounded-lg overflow-hidden border border-[rgba(20,33,61,.15)] mb-3.5'>
                <button type="button" onClick={() => setCurrentTab(0)}
                className={'flex-1 py-2.5 text-[12.5px] font-semibold capitalize transition-colors cursor-pointer ' + (currentTab === 0 ? 'bg-tan text-white' : 'bg-ivory text-[rgba(20,33,61,.55)] hover:bg-[rgba(20,33,61,.04)]')}
                >Attorney Details</button>
                <button type="button" onClick={() => setCurrentTab(1)}
                className={'flex-1 py-2.5 text-[12.5px] font-semibold capitalize transition-colors cursor-pointer ' + (currentTab === 1 ? 'bg-tan text-white' : 'bg-ivory text-[rgba(20,33,61,.55)] hover:bg-[rgba(20,33,61,.04)]')}
                >{currentProf?.assistantId?.legalType} Details</button>
            </div>
        }
     {
            currentProf?.assistantId  &&
            <div className='flex items-start gap-2 text-[12.5px] text-navy rounded-lg border border-[rgba(20,33,61,.12)] bg-[rgba(20,33,61,.03)] px-3.5 py-2.5 w-full mb-3.5'>
                <InfoIcon/>
                <span>This request has been sent by the attorney's assistant. Kindly review the information of both the attorney and the assistant by navigating through the provided tabs.</span>
            </div>
        }
    <div className='flex w-full flex-col justify-center items-center'>
            <div className='w-full text-sm'>
                {currentTab === 0 ?
                (teamupFunderDetails ?
                <div className='flex flex-col lg:flex-row gap-3.5'>
                    <DetailCard person={teamupFunderDetails?.userId} profData={profData}/>
                    <DetailCard person={currentProf?.userId} profData={profData}/>
                </div>
                :
                <DetailCard person={currentProf?.userId} profData={profData}/>)
            :
            currentProf?.assistantId &&

                currentProf?.assistantId?._id !== undefined ?
                <DetailCard person={currentProf?.assistantId} profData={attorneyProfData}/>
                :
                <div className='flex w-full justify-center items-center text-center text-[13px] text-[rgba(20,33,61,.5)] rounded-[14px] border border-[rgba(20,33,61,.12)] bg-ivory p-6'>
                    The assistant who requested this case has deleted their account.<br/> Now the legal professional or a new assistant will be reviewing this case.
                </div>


            }
            </div>

            {contentStep === 2 && caseDetails?.userCase?.closed?.length === 0 ?
            <div className={'flex gap-2.5 w-full mt-4' + (inSheet ? ' sticky bottom-0 bg-ivory pt-3 pb-4 lg:static lg:pt-0 lg:pb-0 lg:bg-transparent' : '')}>
                <button type="button"
                className='flex-1 flex items-center justify-center gap-1.5 rounded-lg bg-tan text-white py-3 text-[13.5px] font-semibold hover:bg-tanDark transition-colors cursor-pointer'
                onClick={() =>
                {
                    if(currentProf?.userId?.isUserFunder)
                    {
                        setApproveDetail(currentProf);
                        setShowConfirmPopup(true);
                    }
                    else
                    {

                        onApprove(currentProf);
                    }
                }}

                ><Check size={15}/>Approve</button>
                <button type="button"
                className='flex-1 rounded-lg border border-[rgba(20,33,61,.2)] text-navy py-3 text-[13.5px] font-semibold hover:bg-[rgba(20,33,61,.04)] transition-colors cursor-pointer'
                onClick={() => onDeny(currentProf)}
                >Deny</button>
            </div>
            :
            (contentStep === 5 ?
            <div className={'flex gap-2.5 w-full mt-4' + (inSheet ? ' sticky bottom-0 bg-ivory pt-3 pb-4 lg:static lg:pt-0 lg:pb-0 lg:bg-transparent' : '')}>
                <button type="button"
                className='flex-1 rounded-lg bg-tan text-white py-3 text-[13.5px] font-semibold hover:bg-tanDark transition-colors cursor-pointer'
                onClick={() => setShowModal(true)}
                >Close case</button>
                <button type="button"
                className='flex-1 rounded-lg border border-[rgba(20,33,61,.2)] text-navy py-3 text-[13.5px] font-semibold hover:bg-[rgba(20,33,61,.04)] transition-colors cursor-pointer'
                onClick={() => onKeepCaseOpen(currentProf)}
                >Keep the case open</button>
            </div>
            :
            "")
            }


    </div>
    </div>
   </div>
  )
}

export default ProfessionalDetailsSubModal
